//@flow

// Vendors
import React, { type Node } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { replace } from 'connected-react-router';

// Components
import { Loading } from '../../components';

type Props = {
  isAuthenticated: boolean,
  replace: Function,
  children: Node,
};

const PublicLayoutBase = ({ isAuthenticated, replace, children }: Props) =>
  isAuthenticated && window.location.pathname !== '/terms-conditions'
    ? replace('/dashboard') || <Loading />
    : children;

const mapStateToProps = ({ auth: { isAuthenticated } }): Object => ({
  isAuthenticated,
});
const mapDispatchToProps = (dispatch: Object) =>
  bindActionCreators({ replace }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PublicLayoutBase);
